import React from 'react';
import findIndex from 'lodash/findIndex';
import { ChromePicker } from 'react-color';
import {BasicDropDownMenu} from '../../../application-controls'
// CLASSGROUP=custom&
// class1_1=0&
// class1_2=2&
// class2_1=2&
// class2_2=6&
// class3_1=6&
// class3_2=15&
// class4_1=15&
// map.layer[cog_xyz].class[class_1].style[0]=COLOR+255+165+0&
// map.layer[cog_xyz].class[class_2].style[0]=COLOR+140+190+237&
// map.layer[cog_xyz].class[class_3].style[0]=COLOR+100+139+217&
// map.layer[cog_xyz].class[class_4].style[0]=COLOR+84+84+179
// rgb(210, 203, 88)
const mainClasses = 4;
const secClass = 2;
const  rasterClassKeys=['1','2','3','4'];


class RasterColor extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      visible:false
    }
    this.togglePicker =this.togglePicker.bind(this);
    this.onChangeComplete =this.onChangeComplete.bind(this);
  }

  onChangeComplete(color) {
    const {handleColorChange, rasterClass} =this.props;
    handleColorChange(color, rasterClass.name)
  }
  togglePicker() {
    const {visible}=this.state;
    this.setState({visible:!visible})
  }
  render(){
    const { visible } = this.state;
    const { rasterClass } = this.props;
    const popover = {
      position: 'absolute',
      zIndex: '2',
    }
    const cover = {
      position: 'fixed',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
    }
    const colorArray = (rasterClass.color).split(' ');
    let content = null
    if(visible) {
      content=(
        <div style={popover}>
          <div style={ cover } onClick={ this.togglePicker }/>
          <ChromePicker disableAlpha={true} color={{ r: colorArray[0], g: colorArray[1], b: colorArray[2] }}  onChangeComplete={this.onChangeComplete}/>
        </div>
        
      )
    }else{
      content =(
        <button type="button" className="btn btn-sm btn-primary" style={{width:'16px', height:'16px', backgroundColor:`rgb(${colorArray[0]},${colorArray[1]},${colorArray[2]})`}} onClick={this.togglePicker}/>
      )
    }
    return (
      content
    )
  }
}

class RasterReclass extends React.Component {
  constructor(props){
    super(props);
    let rasterClass;
    if(props.layer.info.rasterClass && props.layer.info.rasterClass.length>0) {
      rasterClass= props.layer.info.rasterClass;
    }else{
      rasterClass=[
        {
          name:'4_1',
          low: 0,
          high: 2,
          color:'203 242 245'
        },
        {
          name:'4_2',
          low:2,
          high:6,
          color:'140 190 237'
        },
        {
          name:'4_3',
          low:6,
          high:15,
          color:'100 139 217'
        },
        {
          name:'4_4',
          low:15,
          high: null,
          color:'84 84 179'
        }
      ]
    }
    this.state = {
      hasChanges: false,
      menuOpen:false,
      value:rasterClass ? (rasterClass.length.toString()) : '4',
      rasterClassName:`custom${(rasterClass ? (rasterClass.length.toString()) : '4')}`,
      selectedOption:props.layer.info.classGroup,
      options:props.layer.info.rasterOptions || ['depth', 'traffic', 'nhc', 'custom'],
      rasterClass:rasterClass,
      rasterClassDefaults: {
        '1':{
            name:'custom1',
            classes:[
              {
                name:'1_1',
                low: 0,
                high: null,
                color:'203 242 245'
              },
            ]
          },
        '2':{
              name:'custom2',
              classes:[
                {
                  name:'2_1',
                  low: 0,
                  high: 2,
                  color:'203 242 245'
                },
                {
                  name:'2_2',
                  low:2,
                  high:null,
                  color:'140 190 237'
                },
              ]
            },
        '3':{
              name:'custom3',
              classes:[
                {
                  name:'3_1',
                  low: 0,
                  high: 2,
                  color:'203 242 245'
                },
                {
                  name:'3_2',
                  low:2,
                  high:6,
                  color:'140 190 237'
                },
                {
                  name:'3_3',
                  low:6,
                  high:null,
                  color:'100 139 217'
                },
              ]
            },
        '4':{
            name:'custom4',
            classes:[
            {
              name:'4_1',
              low: 0,
              high: 2,
              color:'203 242 245'
            },
            {
              name:'4_2',
              low:2,
              high:6,
              color:'140 190 237'
            },
            {
              name:'4_3',
              low:6,
              high:15,
              color:'100 139 217'
            },
            {
              name:'4_4',
              low:15,
              high: null,
              color:'84 84 179'
            }
          ]
        }
      }
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.renderOptions = this.renderOptions.bind(this);
    this.renderRasterClass = this.renderRasterClass.bind(this);
    this.checkRasterClassObj = this.checkRasterClassObj.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleColorChange = this.handleColorChange.bind(this);
    this.handleClassChange = this.handleClassChange.bind(this);
  }
  handleClassChange(val) {    
    const {value, rasterClass, rasterClassDefaults} = this.state;
    if(val !== value) {
      const {name, classes} = rasterClassDefaults[val];
      this.setState({value: val, rasterClass:classes, rasterClassName: name, hasChanges:true});
    }    
  }
  
  
  handleSave(){
    const { layer } = this.props;
    const {selectedOption, rasterClass, rasterClassName, rasterClassDefaults, value} = this.state;
    layer.info.classGroup = selectedOption;
    const lyrSrc = layer.mapLayer.getSource()
    const rawUrls =lyrSrc.getUrls();
    const url = new URL(rawUrls[0]);
    const urlSearchParams = new URLSearchParams(url.search);
    urlSearchParams.set('CLASSGROUP', selectedOption==='custom' ? rasterClassName : selectedOption);
    urlSearchParams.delete('tile');
    for(let i=0;i<rasterClassKeys.length;i++) {
      const obj =rasterClassDefaults[rasterClassKeys[i]];
      for(let j=0;j<obj.classes.length;j++) {       
        urlSearchParams.delete(`class_${i+1}_${j+1}`);
        if(j===0 && i===0) {
          urlSearchParams.delete(`class_${i+1}_${j+2}`);
        }
        urlSearchParams.delete(`map.layer[cog_xyz].class[color_${rasterClassKeys[i]}_${j+1}].style[0]`);
      }
    }    
    let newUrl = `${url.origin}${url.pathname}?${urlSearchParams.toString()}&tile={x}+{y}+{z}`;
    if(selectedOption==='custom') {
      for(let i=0; i< rasterClass.length; i++) {
        const {name, color, low, high} = rasterClass[i];
        const colorArr = color.split(' ')
        const colorString = colorArr.join('+');
        newUrl = newUrl +`&map.layer[cog_xyz].class[color_${name}].style[0]=COLOR+${colorString}&class_${i+1}_1=${low}&class_${i+1}_2=${high}`
      }
    }
    layer.info.rasterClass=rasterClass
    lyrSrc.setUrls([newUrl])
    this.setState({hasChanges: false})  
  }
  checkRasterClassObj() {
    console.log('checking changes')
  }
  
  handleChange(e){
    const { layer } = this.props;
    const val = e.currentTarget.dataset.rasterclass;
    let hasChanges =false;
    if(val!=='custom' && val !==layer.info.classGroup) {
      hasChanges=true;
    }
    this.setState({selectedOption:val, hasChanges});
  }
  
  handleInputChange(e){
    const { rasterClass } = this.state;
    const { layer } = this.props;
    const rasterClassName = e.currentTarget.dataset.classname;
    const valName = e.currentTarget.dataset.classval;
    const currClassIdx = findIndex(rasterClass, {name:rasterClassName});
    const newcurrClass = Object.assign({},rasterClass[currClassIdx] );
    newcurrClass[valName] = Number(e.currentTarget.value);
    rasterClass.splice(currClassIdx, 1, newcurrClass);
    this.setState({rasterClass:rasterClass, hasChanges:true})
  }
  renderOptions() {
    const {selectedOption, options, hasChanges} = this.state;

    const optArr =[]
    options.map((val,idx) =>{
      let classStr="btn btn-sm btn-default"
      const pressed = (val===selectedOption);
      if(pressed === true) {
        classStr="btn btn-sm btn-default active"
      }
      optArr.push(<button key ={`${val}-${idx}`} type="button" className={classStr} aria-pressed={pressed} data-rasterclass={val} onClick={this.handleChange}>{val}</button>)
    })
    return( 
    <div style={{display:'flex', justifyContent:'space-between', marginBottom:'14px'}}>
      
      <div className="btn-toolbar">
        <div className="btn-group btn-group-toggle" role="group" data-toggle="buttons">
          {optArr}
        </div>        
      </div>
      <button type="button" className="btn btn-sm btn-primary" style={{height:'28px', alignSelf:'center'}} disabled={!hasChanges} onClick={this.handleSave}>SAVE</button>
    </div>
    );
  }
  renderRasterClass() {
    const { layer } = this.props;
    const {selectedOption, rasterClass, menuOpen, value} = this.state
    const selectedRasterClass = rasterClass;
    if(selectedOption==='depth') {
      const src = layer.url + `&service=WMS&version=1.1.1&request=GetLegendGraphic&format=image/png&sld_version=1.1.0&layer=${layer.layerList}&CLASSGROUP=depth`;      
      return (
      <div style={{display:'flex', flexDirection:'column'}}>
        <ul className="list-group">
          <li className="list-group-item">
            <div className="overflow-ellipsis" title='Depth Classification'><strong>Depth Classification</strong></div>
            <img alt={`Example of style for Depth Classification`} src={ src }></img>
          </li>
        </ul>
      </div>)
    }else if(selectedOption==='traffic') {
      const src = layer.url + `&service=WMS&version=1.1.1&request=GetLegendGraphic&format=image/png&sld_version=1.1.0&layer=${layer.layerList}&CLASSGROUP=traffic`;      
      return (
      <div style={{display:'flex', flexDirection:'column'}}>
        <ul className="list-group">
          <div className="overflow-ellipsis" title='Traffic Classification'><strong>Traffic Classification</strong></div>
          <li className="list-group-item">
            <div key={`customLegend-minor`} style={{width:'100%', display:'flex', marginBottom:'2px', alignItems:'center'}}>
              <svg width="24" height="12" xmlns="http://www.w3.org/2000/svg" version="1.1" style={{marginRight:'6px'}}>
                <rect x="0" y="0" width="24" height="12" fillOpacity='1' fill={`rgb(51, 153, 51)`}/>
              </svg>
              0.05m-0.3m Minor flooding begins, cars still passable
            </div>
          </li>
          <li className="list-group-item">
            <div key={`customLegend-semi`} style={{width:'100%', display:'flex', marginBottom:'2px', alignItems:'center'}}>
              <svg width="24" height="12" xmlns="http://www.w3.org/2000/svg" version="1.1" style={{marginRight:'6px'}}>
                <rect x="0" y="0" width="24" height="12" fillOpacity='1' fill={`rgb(255, 102, 0)`}/>
              </svg>
              0.3m-1.0m Cars not passable, high trucks ok
            </div>
            </li>
            <li className="list-group-item">
            <div key={`customLegend-ht`} style={{width:'100%', display:'flex', marginBottom:'2px', alignItems:'center'}}>
              <svg width="24" height="12" xmlns="http://www.w3.org/2000/svg" version="1.1" style={{marginRight:'6px'}}>
                <rect x="0" y="0" width="24" height="12" fillOpacity='1' fill={`rgb(255, 0, 0)`}/>
              </svg>
              1.0m-2.0m High trucks not ok, emergency vehicles ok
            </div>
            </li>
            <li className="list-group-item">
            <div key={`customLegend-nk`} style={{width:'100%', display:'flex', marginBottom:'2px', alignItems:'center'}}>
              <svg width="24" height="12" xmlns="http://www.w3.org/2000/svg" version="1.1" style={{marginRight:'6px'}}>
                <rect x="0" y="0" width="24" height="12" fillOpacity='1' fill={`rgb(0, 0, 255)`}/>
              </svg>
              2.0m-3.0m Emergency vehicles not ok
            </div>
            </li>
            <li className="list-group-item">
            <div key={`customLegend-nk`} style={{width:'100%', display:'flex', marginBottom:'2px', alignItems:'center'}}>
              <svg width="24" height="12" xmlns="http://www.w3.org/2000/svg" version="1.1" style={{marginRight:'6px'}}>
                <rect x="0" y="0" width="24" height="12" fillOpacity='1' fill={`rgb(0, 0, 0)`}/>
              </svg>
              3.0m+ First floor underwater
            </div>
          </li>
            
        </ul>
      </div>)
    }else if(selectedOption==='nhc') {
      const src = layer.url + `&service=WMS&version=1.1.1&request=GetLegendGraphic&format=image/png&sld_version=1.1.0&layer=${layer.layerList}&CLASSGROUP=nhc`;      
      return (
      <div style={{display:'flex', flexDirection:'column'}}>
        <ul className="list-group">
          <div className="overflow-ellipsis" title='National Hurricane Center Classification'><strong>National Hurricane Center Classification</strong></div>
          <li className="list-group-item">
            <div key={`customLegend-minor`} style={{width:'100%', display:'flex', marginBottom:'2px', alignItems:'center'}}>
              <svg width="24" height="12" xmlns="http://www.w3.org/2000/svg" version="1.1" style={{marginRight:'6px'}}>
                <rect x="0" y="0" width="24" height="12" fillOpacity='1' fill={`rgb(34, 34, 34)`}/>
              </svg>
               0 - 1ft
            </div>
          </li>
          <li className="list-group-item">
            <div key={`customLegend-semi`} style={{width:'100%', display:'flex', marginBottom:'2px', alignItems:'center'}}>
              <svg width="24" height="12" xmlns="http://www.w3.org/2000/svg" version="1.1" style={{marginRight:'6px'}}>
                <rect x="0" y="0" width="24" height="12" fillOpacity='1' fill={`rgb(4, 103, 228)`}/>
              </svg>
              1 - 3ft
            </div>
            </li>
            <li className="list-group-item">
            <div key={`customLegend-ht`} style={{width:'100%', display:'flex', marginBottom:'2px', alignItems:'center'}}>
              <svg width="24" height="12" xmlns="http://www.w3.org/2000/svg" version="1.1" style={{marginRight:'6px'}}>
                <rect x="0" y="0" width="24" height="12" fillOpacity='1' fill={`rgb(228, 228, 4)`}/>
              </svg>
              3 - 6ft
            </div>
            </li>
            <li className="list-group-item">
            <div key={`customLegend-nk`} style={{width:'100%', display:'flex', marginBottom:'2px', alignItems:'center'}}>
              <svg width="24" height="12" xmlns="http://www.w3.org/2000/svg" version="1.1" style={{marginRight:'6px'}}>
                <rect x="0" y="0" width="24" height="12" fillOpacity='1' fill={`rgb(228, 153, 4)`}/>
              </svg>
              6 - 9ft
            </div>
            </li>
            <li className="list-group-item">
            <div key={`customLegend-nk`} style={{width:'100%', display:'flex', marginBottom:'2px', alignItems:'center'}}>
              <svg width="24" height="12" xmlns="http://www.w3.org/2000/svg" version="1.1" style={{marginRight:'6px'}}>
                <rect x="0" y="0" width="24" height="12" fillOpacity='1' fill={`rgb(228, 4, 4)`}/>
              </svg>
              <span>{`> 9ft`}</span>
            </div>
          </li>
            
        </ul>
      </div>)
    }else if(selectedOption==='custom') {
      const classOptions=(
        <BasicDropDownMenu value={value} selectValue={this.handleClassChange} label='Select Number of Classes' options={[
          {value: '1', label: '1'},
          {value: '2', label: '2'},
          {value: '3', label: '3'},
          {value: '4', label: '4'},
        ]}/>
        
      )
      return(
       <>
       <div style={{display:'flex', flexDirection:'row'}}>
       
        <label style={{marginRight:'18px'}}>Select Number of Classes:</label>
        {classOptions}
       </div>
       
       {
         selectedRasterClass.map((obj, idx, arr)=>{
           let content =null;
           if(obj.high !== null) {
             let label;
             if(idx===0) {
               label =(<label className="control-label">Potential Inundation Value Range:</label>);
             }
             content = (
               <div key={`${obj.name}-${idx}`}>
                 <hr/>
                 {label}
                 <div style={{height:'26px', display:'flex', flexDirection:'row', justifyContent: 'center', alignItems: 'center'}}>                  
                    <input type="number" className="control-label" min="0" style={{width:'42px'}} data-classname={obj.name} data-classval='low' onChange={this.handleInputChange} value={obj.low}/>
                    <b style={{marginLeft:'12px', marginRight:'12px'}}>TO</b>
                    <input type="number" className="control-label" style={{width:'42px'}} data-classname={obj.name} data-classval='high' onChange={this.handleInputChange} value={obj.high}/>
                    <RasterColor rasterClass={obj} handleColorChange={this.handleColorChange}/>
                  </div>
                  </div>
                  )
                    }else{
                      content = (
                        <div key={`${obj.name}-${idx}`}>
                          <hr/>
                          <div style={{height:'26px', display:'flex', flexDirection:'row', justifyContent: 'center', alignItems: 'center'}}>
                          <b style={{marginLeft:'12px', marginRight:'12px'}}>{`All Values >`} </b>
                            <input type="number" className="form-control" min="0" style={{width:'42px'}} data-classname={obj.name} data-classval='low' onChange={this.handleInputChange} value={obj.low}/>
                            
                            <RasterColor rasterClass={obj} handleColorChange={this.handleColorChange}/>
                          </div>
                          
                        </div>
                          )
                    }
              return content
            })
          }
          
      
        </>
  
      )
    }
    
    
    
  }
  handleColorChange(color, name) {
    const {rasterClass} = this.state;
    const rasterClassName = name;
    const valName = 'color';
    const currClassIdx = findIndex(rasterClass, {name:rasterClassName});
    const newcurrClass = Object.assign({}, rasterClass[currClassIdx]);
    newcurrClass[valName] = `${color.rgb.r} ${color.rgb.g} ${color.rgb.b}`;
    rasterClass.splice(currClassIdx, 1, newcurrClass)
    this.setState({rasterClass: rasterClass, hasChanges:true});
  }
  render(){
    const { rasterClass } = this.state;
    return (
      <div style={{display:'flex', flexDirection:'column'}}>
        <hr style={{marginTop:'12px'}}/>
        {this.renderOptions()}
        
        {this.renderRasterClass()}
        
      </div>
    )
  }
}

export default RasterReclass;